import TagSelectBloc from '../../../shared/tagSelectBloc/TagSelectBloc.vue'

export default {
  name: 'UserLanguages',
  components: { TagSelectBloc },
  props: {
    languages: {
      type: Array,
      default: () => []
    },
    editedLanguages: {
      type: Array,
      default: () => []
    },
    editable: Boolean
  },
  computed: {
    allLanguages() {
      return this.$store.getters.languages
    }
  },
  methods: {
    async addLanguage(language) {
      return this.editedLanguages.push(language)
      // return this.$store.dispatch('addLanguage', language)
    },
    removeLanguage(language) {
      const i = this.editedLanguages.map(item => item.id).indexOf(language.id)
      this.editedLanguages.splice(i, 1)
      // .$store.dispatch('removeLanguage', language.id)
    }
  }
}
